import classNames from 'classnames'
import {SearchGroupIcon} from 'components/AppIcon'
import _ from 'lodash'
import Translate from 'modules/local/Translate'
import React, {useCallback, useContext} from 'react'
import {IoCalendarClearOutline} from 'react-icons/io5'
import {NavLink, Redirect, Route, Switch, useRouteMatch,} from 'react-router-dom'
import {withProps} from 'recompose'
import {staticPaths} from 'routes/staticPaths'
import {mapPathParam} from 'views/AppLocals/functions/routerHelper'
import {Queries} from 'views/Shared/enums/Queries'
import useTranslate from "../../../modules/local/useTranslate";
import {useLocation} from "react-use";
import WorkspaceContext from "../WorkspaceContext";
import EmptyHolder from "../../../components/EmptyHolder";
import {HiOutlineLockClosed} from "react-icons/hi2";
import getTitle from "../../../helpers/getTitle";
import {HiOutlineMenuAlt2} from "react-icons/hi";
import {LayoutContext} from "../../../components/layouts/Default/LayoutContext";

const rootPath = staticPaths.workspace.pathname

const renderFeatureItem = (type, {url, label, disabled = false}) => {
    if (_.isEmpty(type)) return null

    const Component = !!disabled
        ? 'div'
        : withProps({
            to: url,
            activeClassName: 'menu-workspace-active',
        })(NavLink)

    return (
        <Translate key={type}>
            {(t) => (
                <Component
                    style={{
                        minWidth: '5.5rem',
                        width: '100%',
                        height: '5.5rem',
                    }}
                    className={classNames(
                        'flex flex-col flex-center gap-2 rounded-lg no-underline p-2 shadow hover:shadow-md ',
                        !!disabled && 'disable'
                    )}>
                    <SearchGroupIcon
                        type={type}
                        size={25}
                        FallbackComponent={IoCalendarClearOutline}
                    />
                    <span className="font-medium text-center text-xs tracking-wider">{t(label)}</span>
                </Component>
            )}
        </Translate>
    )
}

const WorkspaceFeatures = ({
    activeKey,
    routes = [],
    defaultAction,
    Wrapper = 'div',
    actionField = Queries.ACTION,
    isDisabled = (route) => false,
}) => {
    const t = useTranslate();
    const {path: root, ...restRoute} = useRouteMatch()
    const location = useLocation();
    const {organization} = useContext(WorkspaceContext)
    const {isLg, setOpenMenu, openMenu} = useContext(LayoutContext)

    const getPath = useCallback(
        (key) => {
            if (root.includes(actionField)) {
                return mapPathParam(root, {
                    [actionField]: key,
                })
            } else {
                return [root, key].join('/')
            }
        },
        [root, actionField]
    )

    if (_.isEmpty(routes)) return null;

    return (
        <Wrapper className="flex flex-col gap-6 container mx-auto">
            <div className="px-3 pt-4 pb-2 background flex items-center gap-3">
                <div className="flex flex-col flex-1 min-w-0">
                    <span className="font-medium text-2xs text-gray-500 uppercase tracking-widest truncate">
                        {getTitle(organization)}
                    </span>
                    <span className="font-bold text-lg text-secondary-600 tracking-wider truncate">
                        {activeKey}
                    </span>
                </div>
                {!isLg && (
                    <button
                        onClick={() => {setOpenMenu(!openMenu)}}
                        style={{ width: '2.25rem', height: '2.25rem', borderRadius: '0.75rem' }}
                        className="flex flex-center background-100 hover:background-200 text-color-200 hover:text-color-100 transition-all duration-300">
                        <HiOutlineMenuAlt2 size={22}/>
                    </button>
                )}
            </div>
            <Switch>
                <Route
                    exact={true}
                    path={rootPath}
                    render={() => <Redirect to={getPath(defaultAction)} push={false}/>}
                />
                {routes.map(({key, required_permissions, isServiceDisabled = (org) => false, ...route}) => {
                    return (
                        <Route
                            key={key}
                            exact={true}
                            path={getPath(key)}
                            {...route}
                            component={!isServiceDisabled(organization) ? route?.component : () => (
                                <EmptyHolder
                                    icon={() => (
                                        <HiOutlineLockClosed size={64} style={{color: "#9ca3af"}}/>
                                    )}
                                    title="feature not enabled"
                                    subTitle="please contact the system administrator to enable access to this feature."
                                />
                            )}
                        />
                    )
                })}
                <Route
                    path="*"
                    render={() => <Redirect to={getPath(defaultAction)} push={false}/>}
                />
            </Switch>
        </Wrapper>
    )
}

export default WorkspaceFeatures
